import { render, staticRenderFns } from "./SignBlock.vue?vue&type=template&id=109aae0c&"
import script from "./SignBlock.vue?vue&type=script&lang=js&"
export * from "./SignBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports